import React from 'react';

import { Typography } from '@mui/material';

import { SimpleObject } from '@clearverify/types';

import { Modal } from 'src/components/common';
import { PermissiblePurposeDeclineModalForm } from 'src/components/permissiblePurpose';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export interface DeclinePermissiblePurposeModalArgs extends SimpleObject {
  permissiblePurposeId: string;
}

export const PermissiblePurposeDeclineModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen, args } =
    useModal<DeclinePermissiblePurposeModalArgs>(ModalId.PermissiblePurposeDeclineModal);

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Permissible Purpose is declined"
      headerPadding="32px 32px 0 32px"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
      maxWidth={540}
    >
      {args?.permissiblePurposeId ? (
        <PermissiblePurposeDeclineModalForm
          permissiblePurposeId={args.permissiblePurposeId}
          closeModal={onCloseModal}
          switchClosability={switchClosability}
        />
      ) : (
        <Typography variant="body2">Permissible Purpose not found</Typography>
      )}
    </Modal>
  );
};
